<template>
  <div class="content">
    <!-- 基本信息 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-weight: bolder">基本信息</span>
      </div>
      <el-descriptions :column="4" :contentStyle="{'font-size': '15px'}" :labelStyle="{'font-weight': 'bold','color':'#303133'}">
        <el-descriptions-item label="ICCID/代理商">{{data.alias}}</el-descriptions-item>
        <el-descriptions-item label="发票类型">{{data.type}}</el-descriptions-item>
        <el-descriptions-item label="抬头类型">{{data.titleType}}</el-descriptions-item>
        <el-descriptions-item label="发票抬头">{{data.title}}</el-descriptions-item>
        <el-descriptions-item label="公司税号">{{data.ein}}</el-descriptions-item>
        <el-descriptions-item label="收票手机号">{{data.phone}}</el-descriptions-item>
        <el-descriptions-item label="邮箱收票">{{data.email}}</el-descriptions-item>

        <el-descriptions-item label="基本户开户银行" v-if="data.type == '增值税专用发票'">{{data.bank}}</el-descriptions-item>
        <el-descriptions-item label="基本户开户账号" v-if="data.type == '增值税专用发票'">{{data.bankAccount}}</el-descriptions-item>
        <el-descriptions-item label="基本户开户名" v-if="data.type == '增值税专用发票'">{{data.basicName}}</el-descriptions-item>
        <el-descriptions-item label="公司联系方式" v-if="data.type == '增值税专用发票'">{{data.businessPhone}}</el-descriptions-item>
        <el-descriptions-item label="公司注册地址" v-if="data.type == '增值税专用发票'">{{data.businessAddress}}</el-descriptions-item>

        <el-descriptions-item label="开票金额">{{data.money}}</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{data.createTime}}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card class="box-card" v-if="checkPermi(['order:invoice:showOperate'])">
      <div slot="header" class="clearfix">
        <span style="font-weight: bolder">操作处理</span>
      </div>
      <!-- 客服审核 -->
      <div v-if="checkPermi(['order:invoice:audit'])" class="audit-block">
        <el-form ref="shform" :model="shform" :rules="shrules" label-width="80px" class="form-class" >
          <el-row>
            <el-col :span="8">
              <el-form-item label="审核状态" prop="status">
                <el-select v-model="shform.status" filterable clearable placeholder="请选择审核状态" style="width:300px">
                  <el-option v-for="item in optOrderStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="备注" prop="remark">
                <el-input type="text" placeholder="请输入备注" autocomplete="off" v-model="shform.remark" style="width:300px"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item>
                <!-- 0 拒绝 1 审核中 2 已通过 3 已开票 4 已寄出 -->
                <el-button type="primary" size="medium" @click="csSubmit('form')" v-if="data.status == '1' || data.status == '2'" >信息审核</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 财务审批 -->
      <div v-if="checkPermi(['order:invoice:approve'])"   class="audit-block">
          <el-form ref="shform" :model="shform" :rules="shrules" label-width="80px" class="form-class" >
              <el-form-item label="审批结果" prop="status">
                <el-select v-model="queryParams.status" filterable placeholder="审批结果" clearable>
                  <el-option v-for="item in source" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发票图片" prop="url" v-loading="dataLoading">
                <el-input class="mb10 input-layout" type="textarea" :rows="4" placeholder="粘贴图片即可上传" v-model="uploadImg" @paste.native="handlePaste" style="width:25%" ></el-input>
                <el-upload
                    :file-list="srcList"
                    :action="uploadUrl"
                    :headers="headers"
                    :on-success="uploadSuccess"
                    :class="{ hideUpload: srcList.length >= 1 }"
                    :limit="1"
                    accept=".png,.jpg,.jpeg.gif"
                    list-type="picture-card">
                  <i slot="default" class="iconfont iconda_jiahao fs24"></i>
                  <div slot="file" slot-scope="{ file }">
                    <el-image fit="cover" :src="file.url"></el-image>
                    <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file.url)">
                            <i class="el-icon-search"></i>
                        </span>
                        <span class="el-upload-list__item-delete" @click="uploadRemove(srcList, file.url)">
                            <i class="el-icon-delete"></i>
                        </span>
                    </span>
                  </div>
                </el-upload>
                <el-image-viewer class="modal-image" title="图片预览" :url-list="[dialogImageUrl]" v-if="dialogImgVisible" :on-close="closePreview"></el-image-viewer>
              </el-form-item>
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" :rows="4" v-model="queryParams.remark" placeholder="请输入备注意见" style="width:50%"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="financeSubmit" style="margin-top: 20px;">开票审批</el-button>
              </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-tabs v-model="activeName" @tab-click="handleClick" >
      <el-tab-pane label="子发票列表" name="invoiceChildren" v-if="checkPermi(['order:invoice:childrenAndOrderList']) && data.parentId === -1">
        <invoiceChildren ref="invoiceChildrenRef" :invoiceid="+this.id"></invoiceChildren>
      </el-tab-pane>
      <el-tab-pane label="订单列表" name="invoiceOrderList" v-if="checkPermi(['order:invoice:childrenAndOrderList']) && data.parentId !== -1"  >
        <invoiceOrderList ref="invoiceOrderListRef" :invoiceid="+this.id"></invoiceOrderList>
      </el-tab-pane>
      <el-tab-pane label="操作记录" name="invoiceOperationList" v-if="checkPermi(['order:invoice:operationList'])">
        <invoiceOperationList ref="invoiceOperationListRef" :invoiceid="+this.id"></invoiceOperationList>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>
import {invoiceApprove, invoiceDetail} from "@/api/api.js";//获取详情
import { invoiceAudit } from "@/api/api.js";
import invoiceChildren from "@/components/invoice/InvoiceChildren.vue";
import invoiceOperationList from "@/components/invoice/InvoiceOperationList.vue";
import invoiceOrderList from "@/components/invoice/InvoiceOrderList.vue";
import { getToken } from "@/utils/auth";
import axios from 'axios'
import elImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  name:'invoiceDetail',
  data() {
    return {
      id:this.$route.params && this.$route.params.id,
      data: {},
      childrenData:[],
      orderData:[],
      form:{},
      shform:{},
      wlxxfrom:{},
      optOrderStatus:[
        { value: 0, label: "未通过" },
        { value: 2, label: "已通过" },
        { value: 7, label: "不开票" },
      ],
      source:[
        {value:3, label:"同意"},
        {value:6, label:"不同意"},
      ],
      shrules:{
        status:[
          { required: true, message: "请选择审核状态", trigger: "blur" }
        ]
      },
      rules: {
        courierName: [
          { required: true, message: "快递公司不可为空", trigger: "blur" }
        ],
        courierNum: [
          { required: true, message: "快递单号不可为空", trigger: "blur" }
        ],
      },
      page: 1,
      pageSize: 20,
      total:0,
      activeName: "invoiceChildren",
      // 财务提交
      queryParams:{
        remark:"",
        invoiceUrl:"",
      },
      // 上传图片相关
      url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API + '/upload/uploadImage',
      uploadUrl: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API + "/file/upload/invoiceImg",
      headers: {
        Authorization: "Bearer " + getToken()
      },
      loading: false,
      hideUpload: false,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      srcList: [],
      statusArr: [],
      dialogImgVisible: false,
      uploadImg: '',
      imgFile: '',
      dataLoading: false
    };
  },
  components: {
    invoiceChildren,
    invoiceOperationList,
    invoiceOrderList,
    elImageViewer
  },
  computed: {},
  methods: {
    handleClick(tab) {
      if (tab.name === "invoiceChildren") {
        this.$refs.invoiceChildrenRef.initData();
      }else if(tab.name === "invoiceOrderList"){
        this.$refs.invoiceOrderListRef.initData();
      }else if(tab.name === "invoiceOperationList"){
        this.$refs.invoiceOperationListRef.initData();
      }
    },
    transferOrderStatus(status) {
      let obj = {
        1: "未发货",
        2: "已发货",
      };
      return obj[status];
    },
    // 初始化信息
    initData(){
      let params = {
        invoiceId :this.id
      }
      invoiceDetail(params).then(res => {
        if(res.data.code == 200){
          this.data = res.data.data;
          this.data.type = this.data.type === "1" ? "电子普通发票" : "增值税专用发票";
          this.data.titleType = this.data.titleType === "1" ? "企业单位" : "个人/事业单位";
          if(this.data.parentId === -1){
            this.activeName = "invoiceChildren";
          } else {
            this.activeName = "invoiceOrderList";
          }
        }
      })
    },
    csSubmit(){
      this.$refs.shform.validate((valid) => {
        if (valid) {
          let params = {
            ...this.shform
          }
          params.invoiceId = this.id
          invoiceAudit(params).then(res=>{
            if(res.data.code == 200){
              for(let i in this.shform){
                this.shform[i]=''
              }
              this.$notify({
                title: '成功',
                message: '发票审核成功',
                type: 'success'
              });
            }
          })
        }
      })
    },
    // 上传图片
    handlePaste(value) {
      this.dataLoading = true
      let file = value.clipboardData.items[0]
      if (file.type.includes('image')) {
        let imgFile = file.getAsFile()
        const formData = new FormData()
        formData.append('file', imgFile)
        const axiosInstance = axios.create({ withCredentials: false })
        axiosInstance({
          header: this.headers,
          method: 'post',
          url: this.uploadUrl, 
          data: formData,
        })
        .then(res => {
          // 调用成功回调
          let data = res.data
          this.dataLoading = false
          this.srcList = [{url:data.data.fullUrl}];
        })
        .catch(function (err) {
          this.dataLoading = false
          // 上传失败
        })
      }
    },
    uploadRemove(item, url) {
      this.srcList = [];
    },
    closePreview() {
      this.dialogImgVisible = false
    },
    handlePictureCardPreview(url) {
      this.dialogImgVisible = true
      this.dialogImageUrl = url
    },
    uploadSuccess(res, file) {
      if (res.code === 200) {
        this.srcList =[{url:res.data.fullUrl}];
      }else{
        this.$notify({
          title: '发票上传',
          message: '发票上传成功',
          type: 'error'
        });
      }
      
    },
    // 财务提交
    financeSubmit(){
      if (this.queryParams.status === 3 && this.srcList.length === 0) return this.$message.error("请上传发票");
      this.queryParams.invoiceUrl = this.srcList.length>0 ? this.srcList[0].url:''
      if (!this.queryParams.remark || !this.queryParams.status) return this.$message.error("请输入审批内容或结果");
      let params = {
        ...this.queryParams,
        invoiceId:this.id
      }
      invoiceApprove(params).then(res=>{
        if(res.data.code == 200){
          this.$router.push({ path: `/order/invoiceManage` });
          this.$notify({ title: '成功', message: '审批成功',type: 'success' });
        }
       })
    },
  },
  created() {
    this.initData();
  },
  mounted() {
  }
};
</script>
<style scoped>
.reg-img{
  max-width: 300px;
  max-height: 300px;
}
.el-form-item__content{
  color: #1890ff;
}
.form-class{
  margin-left: 50px;
  margin-top: 30px;
}
.courier-block{
  border: #d9e2ec solid 1px;
}
.audit-block{
  margin-top: 30px;
  border: #d9e2ec solid 1px;
}


.el-upload-list.el-upload-list--picture-card .el-upload-list__item {
    width: 146px !important;
    height: 146px !important;
    margin-right: 13px;
}
.el-upload-list.el-upload-list--picture-card .el-upload-list__item       .el-image {
  width: 146px;
  height: 146px;
  border-radius: 4px;
}
</style>








